export default __webpack_public_path__ + "static/media/Hot.257767c8.svg";